export const IfTextExist = ({ text, children }) =>
  If({ condition: text && text !== "", children });

export const If = ({ condition, children }) => (condition ? children : null);

export default If;
